import { ApplicationInsightsConfig } from '@raas/shared/src/hooks/useApplicationInsights';
import { isDevelopment, getEnvVar } from '../utils/env';

export enum LEGAL_PROVISION_STATE {
  DEFAULT = 'DEFAULT',
  SHOW_INITIAL_PARAGRAPH = 'SHOW_INITIAL_PARAGRAPH',
  CREATE_ELEMENT = 'CREATE_ELEMENT',
  EDIT_ELEMENT = 'EDIT_ELEMENT',
  SCROLL_TO_ELEMENT = 'SCROLL_TO_ELEMENT',
}

export const createApplicationInsightsConfig = (
  connectionString: string,
  appType: 'internal-ui' | 'external-ui',
  customProperties?: Record<string, any>
): ApplicationInsightsConfig => {
  const baseConfig: ApplicationInsightsConfig = {
    connectionString,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxErrorStatusText: true,
    enableAjaxPerfTracking: false,
    enableUnhandledPromiseRejectionTracking: true,
    maxAjaxCallsPerView: 5,
    disableTelemetry: isDevelopment(),
    samplingPercentage: 50,
    userContext: `${appType}_${Math.random().toString(36).substr(2, 9)}`,
    customProperties: {
      applicationType: appType,
      environment: getEnvVar('NODE_ENV') || getEnvVar('VITE_NODE_ENV') || 'development',
      buildVersion: getEnvVar('REACT_APP_VERSION') || getEnvVar('VITE_VERSION') || 'unknown',
      userType: appType,
      ...customProperties,
    },
  };
  return baseConfig;
};
